var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "cms-page", attrs: { id: "cms" } }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "cmsContent container" }, [
            _c("div", { staticClass: "text-center" }, [
              _c("h1", [_vm._v(_vm._s(_vm.page.title))]),
            ]),
            _vm._v(" "),
            _c("div", { domProps: { innerHTML: _vm._s(_vm.page.content) } }),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("HomeBottom"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }